export default [
  {
    path: "/32cb503d-2119-4472-9a5d-9c806d3aa038",
    children: [
      {
        path: "rolds",
        name: "roles",
        meta: {
          title: "Roles",
          authRequired: true,
          acc: ['y82954'],
        },
        component: () => import("@/views/roles/roles"),
      },
      {
        path: "cretesyas",
        name: "createRole",
        meta: {
          title: "Create Role",
          authRequired: true,
          acc: ['y75060'],
        },
        component: () => import("@/views/roles/new"),
      },
      {
        path: "roleedrt",
        name: "role-1",
        meta: {
          title: "Role",
          authRequired: true,
          acc: ['y51656', 'y16737',],
        },
        component: () => import("@/views/roles/view"),
      },
    ],
  },
];
